module.exports = __webpack_public_path__ + "static/media/fonts-4.672aa67a.svg";